var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "mb-20px"
  }, [_c('v-icon', {
    attrs: {
      "size": "50",
      "color": "secondary"
    }
  }, [_vm._v("mdi-check-circle")])], 1), _vm._m(0), _c('div', {
    staticClass: "mt-30px mt-md-40px"
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "color": "primary",
      "to": "/login"
    }
  }, [_vm._v("로그인 화면으로 이동")])], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h2', {
    staticClass: "tit tit--sm"
  }, [_vm._v("회원가입이 완료되었습니다.")]), _c('div', {
    staticClass: "font-size-16 font-weight-medium mt-10px"
  }, [_vm._v("가입해 주셔서 감사합니다.")])]);
}]

export { render, staticRenderFns }